document.addEventListener('click', function (e) {
  const btn = e.target.closest('.compatible-accessories-add');
  if (!btn) return;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: btn.dataset.variantId,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(() => {
    window.location.reload();
  })
  .catch(console.error);
});
